export default {
  changePageCatalogShopId(context, params) {
    context.commit("set_pageCatalogShopId", params);
  }
};
